/**
 * Форма изменения названия страны в базе
 */
import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { put } from '../../utils/api';
import { Form, FormInput, FormItem } from '../common/Form';

const MAX_LENGTH = 100;

const CountryForm = ({ alpha2, alpha3, name_ru, name_en, onChange }) => {
	const { t } = useTranslation();
	const [ nameRu, setNameRu ] = useState(name_ru);
	const [ nameEn, setNameEn ] = useState(name_en);
    const [ isSaving, setIsSaving ] = useState(false);
    const [ error, setError ] = useState('');

    // Отправка данных
	const onSubmit = async () => {
        setIsSaving(true);
        setError('');

        const result = await put('/countries', { alpha2, alpha3, name_ru: nameRu, name_en: nameEn });

        if(result.error) {
            setError(result.error);
        } else {
			onChange(alpha2, alpha3, nameRu, nameEn);
        }
        setIsSaving(false);
	};

    return (<>
        {isSaving ? <span>{t('common.loading')}</span> :
        <Form
            error={error}
            submit={t('common.save')}
            onSubmit={onSubmit}
            cancel={t('common.cancel')}
            onCancel={() => onChange(alpha2, alpha3, name_ru, name_en)}
        >
            <div className='b main-color'>{t('country.title_edit')} {alpha2}/{alpha3}</div>
            <FormItem>
                <FormInput
                    id='name_ru'
                    type='text'
                    value={nameRu}
                    onChange={setNameRu}
                    placeholder={t('country.name_ru')}
                    //label={t('country.name_ru')}
                    limit={MAX_LENGTH}
                    required={true}
                    disabled={isSaving}
                />
            </FormItem>
            <FormItem>
                <FormInput
                    id='name_en'
                    type='text'
                    value={nameEn}
                    onChange={setNameEn}
                    placeholder={t('country.name_en')}
                    //label={t('country.name_en')}
                    limit={MAX_LENGTH}
                    required={true}
                    disabled={isSaving}
                />
            </FormItem>
        </Form>}
    </>);
};

CountryForm.propTypes = {
    alpha2: PropTypes.string.isRequired, // код альфа2
    alpha3: PropTypes.string.isRequired, // код альфа3
    name_ru: PropTypes.string.isRequired, // название по-русски
    name_en: PropTypes.string.isRequired, // название по-английски
    onChange: PropTypes.func.isRequired, // вызывается при изменении страны
};

export default CountryForm;
